import(/* webpackMode: "eager", webpackExports: ["Select"] */ "/vercel/path0/libs/common/next-ui/src/lib/select/select.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResetPasswordForm"] */ "/vercel/path0/libs/tuning-bytes/users/feature-reset-password/src/lib/components/reset-password-form.component.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/libs/tuning-bytes/users/ui/src/lib/components/error-message.component.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/libs/tuning-bytes/users/ui/src/lib/components/new-user.component.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/libs/tuning-bytes/users/ui/src/lib/components/provider-button.component.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/libs/tuning-bytes/users/ui/src/lib/components/redirect-back.component.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/libs/tuning-bytes/users/ui/src/lib/components/sign-in.component.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/libs/tuning-bytes/users/ui/src/lib/components/sign-out.component.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/libs/tuning-bytes/users/ui/src/lib/providers/auth-provider.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
